// Define available models
export const AI_MODELS = [
    { "value": "gemma2-9b-it", "label": "Gemma2 9B IT" },
    { "value": "llama3-8b-8192", "label": "Llama 3 8B 8192" },
    { "value": "llama3-70b-8192", "label": "Llama 3 70B 8192" },
    { "value": "llama-3.1-8b-instant", "label": "Llama 3.1 8B Instant" },
    { "value": "llama-3.3-70b-versatile", "label": "Llama 3.3 70B Versatile" },
    { "value": "qwen-2.5-coder-32b", "label": "Qwen 2.5 Coder 32B" },
    { "value": "deepseek-r1-distill-qwen-32b", "label": "DeepSeek R1 Distill Qwen 32B" },
    { "value": "deepseek-r1-distill-llama-70b", "label": "DeepSeek R1 Distill Llama 70B" },
];

export const MUST_HAVE_PROMPTS = [
    {
        "shortDisplayText": "Who are you?",
        "displayText": "Ha! What is your name? and who made you?",
        "important": true,
    }
]
export const STARTER_PROMPTS = [
    {
        "shortDisplayText": "Space Exploration",
        "displayText": "Describe a manned mission to Mars and the challenges the crew faces during their journey.",
    },
    {
        "shortDisplayText": "Historical Event",
        "displayText": "Explain the significance of the fall of the Berlin Wall on international relations.",
    },
    {
        "shortDisplayText": "Artificial Intelligence",
        "displayText": "Discuss the ethical implications of artificial intelligence surpassing human intelligence.",
    },
    {
        "shortDisplayText": "Healthy Eating",
        "displayText": "Provide a guide on how to transition to a plant-based diet, including tips for beginners.",
    },
    {
        "shortDisplayText": "Quantum Computing",
        "displayText": "Outline the basics of quantum computing and how it differs from classical computing.",
    },
    {
        "shortDisplayText": "Ancient Civilizations",
        "displayText": "Compare and contrast the social structures of Ancient Egypt and Ancient Greece.",
    },
    {
        "shortDisplayText": "Renewable Energy",
        "displayText": "Analyze the potential impact of solar energy on reducing global carbon emissions.",
    },
    {
        "shortDisplayText": "Mindfulness Meditation",
        "displayText": "Create a step-by-step beginner's guide to mindfulness meditation, highlighting its benefits for mental health.",
    },
    {
        "shortDisplayText": "Wildlife Conservation",
        "displayText": "Discuss current strategies in wildlife conservation and their effectiveness in preserving biodiversity.",
    },
    {
        "shortDisplayText": "Cybersecurity Threats",
        "displayText": "Identify three major cybersecurity threats facing individuals today and suggest ways to protect against them.",
    },
]

export function getRandomSetOfStarterPrompts(count = 2) {
    const shuffled = STARTER_PROMPTS.sort(() => 0.5 - Math.random());

    const result = MUST_HAVE_PROMPTS.concat(shuffled.slice(0, count));

    return result.map((prompt) => ({
        ...prompt,
        value: prompt.displayText,
    }));
}
